import { Control, Controller } from 'react-hook-form';
import SLDSDatepicker from 'components/Inputs/Datepicker/SLDSDatepicker';
import styles from './DatePickerField.module.css';
import cx from 'classnames';
import moment from 'moment';

type Props = {
	name: string;
	label: string;
	control?: Control<any>;
	placeholder?: string | null;
	disabled?: boolean;
	shouldUnregister?: boolean;
	required?: boolean;
	className?: any;
};

const DatePickerField: React.FC<Props> = ({
	label,
	name,
	control,
	placeholder,
	shouldUnregister = false,
	required,
	className = '',
	...rest
}) => {

	return (
		<>
			<Controller
				name={name}
				control={control}
				shouldUnregister={shouldUnregister}
				render={({
					field: { value: v, onChange, ...fieldRest },
					fieldState: { error },
				}) => {
					const validDate = moment(v, 'MM/DD/YYYY', true).isValid();
					const validDateFormat = moment(v, 'YYYY-MM-DD', true).isValid();

					const formattedValue = v && (validDate|| validDateFormat)
					? moment(v).format('MM/DD/YYYY')
					: moment().format('MM/YYYY');
							
					return (
						<div>
							<SLDSDatepicker
								className={cx({ [styles.errorDateField]: !!error }, className)}
								value={formattedValue}
								{...fieldRest}
								{...rest}
								placeholder={placeholder || label}
								label={
									<label>
										{label}
										{required && (
											<span style={{ color: '#d93025', marginLeft: '0.1vw' }}>
												*
											</span>
										)}
									</label>
								}
								controlled
								onBlur={(event) => {
									event.stopPropagation();
									onChange(event.currentTarget.value);
								}}
								onChange={onChange}
							/>

							{error && (
								<div
									className={cx({
										'slds-has-error': !!error,
									})}
								>
									<div
										className={cx(styles.errorText, 'slds-form-element__help')}
									>
										{error?.message}
									</div>
								</div>
							)}
						</div>
					);
				}}
			/>
		</>
	);
};

export default DatePickerField;
